import type { PropsWithChildren } from 'react';

export type TaskAttributeProps = PropsWithChildren<{
  label: string;
}>;

export function TaskAttribute({ label, children }: TaskAttributeProps) {
  return (
    <div
      className="flex flex-row items-baseline gap-8"
      data-testid="task-attribute"
    >
      <div className="w-48 shrink-0 text-neutral-700">{label}</div>
      <div className="w-full grow">{children}</div>
    </div>
  );
}
